<div class="anpp">
  <div class="modal-header">
    <h4 class="modal-title" translate>
      page.recoltesPp.modalAjouterGroupeVarietal.titre
    </h4>
  </div>


  <div class="modal-body">

      <div class="mb-3">

        <label class="form-label" for="typeahead-http" translate>page.recoltesPp.modalAjouterGroupeVarietal.label</label>

        <select id="groupe"  class="form-select" (change)="selectOperateur()" [(ngModel)]="groupeFilter">
          <option *ngFor="let groupe of groupes" [ngValue]="groupe">{{groupe.libelle}}</option>
        </select>

      </div>
      <div class="actions-bar">
        <button type="button" (click)="onClose()" class="btn btn-light me-2" translate>label.annuler</button>
      </div>

  </div>

</div>

